<template>
  <div style="display: none;">
    <div id="printMe">
      <div class="overlay"></div>
      <div
        v-for="product in productInfos"
        v-bind:key="product.id"
        class="printArea"
        style="max-width : 70mm; max-height: 70mm; min-height: 70mm; margin:auto; text-align:center; align-items: center; display: flex;"
      >
        <div
          v-if="product.distinguish != 'distinguish'"
          style="max-height: 70mm; display: flex; align-items: center; justify-content: center;"
        >
          <table style="width: 70mm; max-height: 70mm; margin: auto; text-align: center; align-items: center;">
            <tr style=" text-align: center; align-items: center; display: flex; justify-content: center; margin-bottom: 10px;">
              <td>
                <font class="poppine-font" style="font-size: 35px !important; font-weight:900;">MERRYFAIR 정품등록</font>
              </td>
            </tr>
            <tr style=" text-align: center; align-items: center;">
              <td>
                <font class="poppine-font" style="font-size: 28px !important; ">{{ cutProductName(product.variantName) }}</font>
              </td>
            </tr>
            <tr style=" text-align: center; align-items: center; margin-bottom: 5px;">
              <td>
                <font
                  class="poppine-font"
                  style="font-size: 26px !important;  padding-bottom: 5px; display: flex; justify-content: center;"
                  >{{ product.authCode }}</font
                >
              </td>
            </tr>
            <tr style=" text-align: center; align-items: center; height: 90px;display: flex; justify-content: center;">
              <td style="display: flex; align-items: center; justify-content: center;">
                <div>
                  <qrcode-vue
                    :value="product.url"
                    level="H"
                    :renderAs="renderAs"
                    :size="QrCodeSize"
                    style="width: 70px; height: 70px;"
                  ></qrcode-vue>
                </div>
                <div style="text-align: center; margin-left: 10px;">
                  <font class="poppine-font" style="font-size: 21px !important;">정품등록하시면<br />최대 3년 무상 AS</font>
                </div>
              </td>
            </tr>

            <tr style="text-align: center; max-height: 5mm; align-items: center;">
              <td style=" text-align: center; align-items: center;padding-top: 0px;">
                <p style="padding:0px; margin:0px; text-align: center;">
                  <font class="poppine-font" style="font-size: 30px !important; font-weight:900;">QR코드 스캔해주세요</font>
                </p>
              </td>
            </tr>
          </table>
        </div>
        <div v-else>
          <table>
            <p
              style="margin:0px; padding:0px; padding-right:2mm; padding-left:2mm; padding-top:5mm; padding-bottom:2mm; text-align: left; font-size: 26px; zoom: 0.5;"
            >
              인쇄매수 : {{ product.variantPrintCount }} ▲
            </p>
            <div>
              <p
                style="margin:0px; padding:0px; padding-top:2mm; padding-left:2mm; padding-right:2mm; font-size: 26px; zoom: 0.5; text-align: left; overflow: hidden; text-overflow: ellipsis;display:-webkit-box; -webkit-line-clamp:2;-webkit-box-orient:vertical;"
              >
                {{ product.productName }}
              </p>
              <p
                style="margin:0px; padding:0px; padding-left:2mm; padding-right:2mm; font-size: 26px; zoom: 0.5; text-overflow: ellipsis; white-space: nowrap; overflow: hidden; text-align: left;"
              >
                옵션 : {{ product.variantName }}
              </p>
              <p style="margin:0px; padding:0px; padding-left:2mm; padding-right:2mm; font-size: 26px; zoom: 0.5; text-align: left;">
                상품코드 : {{ product.productCode }}
              </p>
              <p
                style="margin:0px; padding:0px; padding-bottom:2mm; padding-left:2mm;  padding-right:2mm; font-size: 26px; zoom: 0.5; text-align: left;"
              >
                품목코드 : {{ product.variantCode }}
              </p>
            </div>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import M from "@/libs/mapping.js";
import Vue from "vue";
import QrcodeVue from "qrcode.vue";
import VueHtmlToPaper from "vue-html-to-paper";
import CommonMixin from "@/mixins/CommonMixin.js";
import store from "../../../../store";

const options = {
  name: "_blank",
  specs: ["fullscreen=yes", "titlebar=no", "scrollbars=yes"],
  styles: ["/style/CustomStuhlLabelType1.css"],
};

Vue.use(VueHtmlToPaper);

export default {
  data() {
    return {
      productInfos: [],
      QrCodeValue: "https://" + store.state.mallId + ".cafe24.com",
      QrCodeSize: "70",
      renderAs: "svg",
      tableDatas: [],
      listCount: 0,
    };
  },
  components: {
    QrcodeVue,
  },
  mixins: [CommonMixin],
  methods: {
    btnOnClick: function() {
      this.tableDatas.push({
        itemname: "item",
        quantity: 1,
        sellingprice: 55,
        amount: 55,
      });
    },
    qrPrint: async function() {
      await this.$htmlToPaper("printMe", options);
    },
    qrCodePringttingContents: async function(data) {
      let idx = 0;
      this.productInfos = [];
      for (var productCode in data) {
        for (var variantCode in data[productCode]) {
          let distinguishData = {
            distinguish: "distinguish",
            productName: data[productCode][variantCode][0][0].product_name.replace(/<[^>]+>/gi, ""),
            variantName: data[productCode][variantCode][0][0].variant_name,
            productCode: productCode,
            variantCode: variantCode,
            variantPrintCount: 0,
          };
          for (var i = 0; i < data[productCode][variantCode].length; i++) {
            for (var j = 0; j < data[productCode][variantCode][i][0].print_count; j++) {
              let productName = data[productCode][variantCode][i][0].product_name.replace(/<[^>]+>/gi, "");
              let variantName = data[productCode][variantCode][i][0].variant_name;
              let serialNumber = data[productCode][variantCode][i][0].serial_number;
              let encrySerialNumber = btoa(encodeURI(data[productCode][variantCode][i][0].serial_number));
              let _url = "https://" + store.state.mallId + ".cafe24.com/registration/index.html";
              // 대표도메인 있으면 대표도메인으로
              if (sessionStorage.getItem(`${this.$store.state.mallId}_domain`)) {
                _url = "https://" + sessionStorage.getItem(`${this.$store.state.mallId}_domain`) + "/registration/index.html";
              }
              let QrData = {
                id: this.listCount,
                url: _url + "?authQrCode=" + encrySerialNumber,
                authCode: serialNumber,
                productName: productName,
                variantName,
              };
              this.productInfos.push(QrData);
              this.listCount++;
              if (!this.productInfos[idx].variantPrintCount) {
                this.productInfos[idx].variantPrintCount = 0;
              }
              distinguishData["variantPrintCount"]++;
            }
          }
          this.productInfos.push(distinguishData);
        }
      }
    },
    setQrPrintList: async function(data) {
      let getCount = Object.keys(data).length;
      if (!getCount) {
        alert("선택된 상품이 없습니다.");
        return false;
      }
      await this.qrCodePringttingContents(data);

      if (this.listCount == 0) {
        alert("인쇄수량이 없습니다.");
        return false;
      }
      this.qrPrint();
    },
    /**
     * QR 코드 인쇄 설정 정보 가져오기
     */
    getQrcodeSettingInfo: async function() {},

    cutProductName: function(text) {
      return text.substr(0, 15);
    },
  },
  created: async function() {
    //같은 자식 컴포넌트로 부터 setList 을 emit 한 함수를 on 으로 받아 setProductList 메소드 호출
    this.eventHub.$on("setQrPrintList", this.setQrPrintList);
  },
};
</script>

<style>
.poppine-font {
  font-size: 5px !important;
  zoom: 0.7;
}
</style>
